import { Injectable } from '@angular/core';
import { HttpService } from 'src/common-items/services/http/http.service';
import { Configuration } from 'src/common-items/services/http/configuration';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BassScaResetPasswordApiService {

  constructor(private configuration: Configuration, private httpService: HttpService) { }

  verifyToken(): Observable<any> {
  //   let response = {
  //     "response": {
  //         "mobileNumber": "XXXXXX7110"
  //     },
  //     "errorCode": null,
  //     "errorMessage": null,
  //     "status": "SUCCESS"
  // }
  // return of(response);
    return this.httpService.makeGetReq(this.configuration.getResetPasswordVerifyTokenUrl).pipe(
      map((res:any) => {
        return res;
      })
    );
  } 

  createOTP(data): Observable<any> {
    // let response  = {
    //   "response": {
    //       "type": null,
    //       "sessionTime": "5",
    //       "phoneNumber": null
    //   },
    //   "errorCode": null,
    //   "errorMessage": null,
    //   "status": "SUCCESS"
    // }
    // return of(response);
      return this.httpService.makePostReq(data, this.configuration.getSendOTPUrl)
      .pipe(map((res) => {
        return res;
      }));
    }

    verifyOtp(payLoad: any): Observable<any> {

      // let response = {
      //   "response": {
      //       "userName": "dXXXXXXXXX@yopmail.com",
      //       "otpStatus": "OTP_VERIFIED"
      //   },
      //   "errorCode": null,
      //   "errorMessage": null,
      //   "status": "SUCCESS"
      // }
      // return of(response);
  
      return this.httpService.makePostReq(payLoad, this.configuration.getVerifyOTPUrl)
      .pipe(map((res) => {
        return res;
      }));
    }

    resetPassword(payLoad: any): Observable<any> {

      
      // let response = {
      //   "errorCode": null,
      //   "errorMessage": null,
      //   "status": "SUCCESS"
      // }
      // return of(response);

      return this.httpService.makePostReq(payLoad, this.configuration.getResetPasswordUrl).pipe(
        map((res:any) => {
          return res;
        })
      );
    }

}
